import { Controller } from "@hotwired/stimulus"

// Opens the sign-in modal (shared/_login_modal) in place of navigating when
// a logged-out visitor clicks a link marked `data-login-required`. The
// link's own href is a real sign-in URL; we lift its `return_to` into the
// form, the Reddit button and the sign-up link so every route back lands
// where the visitor was headed.
export default class extends Controller {
  static targets = ["form", "returnTo", "reason", "email", "signUp"]

  intercept(event) {
    const link = event.target.closest("[data-login-required]")
    if (!link || event.defaultPrevented) return
    // Let new-tab / new-window clicks fall through to the full page.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    event.preventDefault()
    this.open(link)
  }

  open(link) {
    const returnTo = this.returnToFrom(link)

    this.returnToTarget.value = returnTo
    this.reasonTarget.textContent = link.dataset.loginReason || "Sign in to keep going."
    this.withReturnTo(this.signUpTarget, returnTo)
    this.element.querySelectorAll("a[href^='/auth/']").forEach((a) => this.withReturnTo(a, returnTo))
    document.getElementById("login_modal_error").textContent = ""

    this.element.showModal()
    this.emailTarget.focus()
  }

  close() {
    this.element.close()
  }

  // Clicks on the dialog element itself (not its contents) are backdrop clicks.
  closeOnBackdrop(event) {
    if (event.target === this.element) this.close()
  }

  returnToFrom(link) {
    try {
      const url = new URL(link.href, window.location.origin)
      return url.searchParams.get("return_to") || window.location.pathname + window.location.search
    } catch {
      return window.location.pathname + window.location.search
    }
  }

  withReturnTo(anchor, returnTo) {
    const url = new URL(anchor.getAttribute("href"), window.location.origin)
    url.searchParams.set("return_to", returnTo)
    anchor.setAttribute("href", url.pathname + url.search)
  }
}
